import { useRef, useState, useEffect } from 'react';
import Image from './assets/lunchliner.svg'
import { useJsApiLoader, GoogleMap, Marker, Autocomplete, DirectionsRenderer } from '@react-google-maps/api'
// import { FaLocationArrow, FaTimes  } from 'react-icons/fa'
import Card from './components/Card';

function App() {

  const [ libraries ] = useState(['places'])
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  })

  const [map, setMap] = useState(/** @type google.maps.Map */(null))
  const [directionsResponse, setDirectionsResponse] = useState(null)
  const [distance, setDistance] = useState(null)
  const [duration, setDuration] = useState(null)
  const [places, setPlaces] = useState([])

  const center = { lat: 30.2672, lng: -97.7431 }
  const [origin, setOrigin] = useState('')
  const [destination, setDestination] = useState('')

  const [searchError, setSearchError] = useState(false)

  const [filter, setFilter] = useState('')

  /** @type React.MutableRefObject<HTMLInputElement> */
  const originRef = useRef('')
  /** @type React.MutableRefObject<HTMLInputElement> */
  const destinationRef = useRef('')

  useEffect(() => {
    if (directionsResponse != null){
      // Query a set of evenly spaced points from the route for nearby restaurants
      const routeLengthInMiles = directionsResponse.routes[0].legs[0].distance.value / 1609.34
      const numQueries = Math.min(Math.max(10, routeLengthInMiles / 80), 20)
      const step = Math.floor(directionsResponse.routes[0].overview_path.length / numQueries)

      // console.log('numQueries', numQueries)

      // console.log(directionsResponse)
      const locations = []
      for(let i = 0; i < numQueries; i++){
        locations.push({
          lat: directionsResponse.routes[0].overview_path[i*step].lat(),
          lng: directionsResponse.routes[0].overview_path[i*step].lng()}
        )
      }
      
      handleRestaurantSearch(locations)
    }
  }, [directionsResponse])

  useEffect(() => {
    filterPlaces(filter)
  }, [filter])

  const filterPlaces = (filterBy) => {
    let temp = [...places]
    if (filterBy == 'nearest'){
      temp.sort((a, b) => {
        return a.index - b.index
      })
    } else if (filterBy == 'farthest'){
      temp.sort((a, b) => {
        return b.index - a.index
      })
    } else if (filterBy == 'cheap'){
      temp.sort((a, b) => {
        if (a.price_level == null){
          return 1
        } else if (b.price_level == null){
          return -1
        }
        return a.price_level - b.price_level
      })
    } else if (filterBy == 'expensive'){
      temp.sort((a, b) => {
        if (a.price_level == null){
          return 1
        } else if (b.price_level == null){
          return -1
        }
        return b.price_level - a.price_level
      })
    } else if (filterBy == 'rated low'){
      temp.sort((a, b) => {
        if (a.rating == null){
          return 1
        }
        return a.rating - b.rating
      })
    } else if (filterBy == 'rated high'){
      temp.sort((a, b) => {
        if (a.rating == null){
          return 1
        }
        return b.rating - a.rating
      })
    }
    setPlaces(temp)
  }

  if (!isLoaded) {
    return (
      <div className='text-black'>
        loading
      </div>
    )
  }

  const calculateRoute = async () => {
    setDirectionsResponse(null)
    setDistance('')
    setDuration('')
    if (originRef.current.value === '' || destinationRef.current.value === ''){
      return
    }
    try {
      // const results = await directionsService.route({
      //   origin: origin,
      //   destination: destination,
      //   // eslint-disable-next-line no-undef
      //   travelMode: google.maps.TravelMode.DRIVING
      // })

      // eslint-disable-next-line no-undef
      const directionsService = new google.maps.DirectionsService()
      const results = await directionsService.route({
        origin: originRef.current.value,
        destination: destinationRef.current.value,
        // eslint-disable-next-line no-undef
        travelMode: google.maps.TravelMode.DRIVING
      })
      setSearchError(false)
      setDirectionsResponse(results)
      setDistance(results.routes[0].legs[0].distance.text)
      setDuration(results.routes[0].legs[0].duration.text)
    } catch(error) {
      setSearchError(true)
    }
  }

  const handleRestaurantSearch = (locations) => {
    // Takes an array of {lat, lng} coordinates to query for restaurants around
    // console.log('locations are', locations)

    let queryResults = []
    locations.map((location, index) => {
      // console.log('working on index', index)
      const request = {
        location: location,
        radius: '2000',
        type: ['restaurant']
      }
  
      const callback = (results, status) => 
      {
        console.log(index)
        // console.log('status', status)

        // eslint-disable-next-line no-undef
        if (status === google.maps.places.PlacesServiceStatus.OK || status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS){
          results.forEach((result) => {
            result['index'] = index
          })
          queryResults = [...queryResults, ...results]
          console.log('queryResults', queryResults)
          if (index == locations.length - 1){
            setPlaces(queryResults)
          }
        // eslint-disable-next-line no-undef
        } else if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT){
          console.log('OVER_QUERY_LIMIT')
          queryResults = [...queryResults]
          setPlaces(queryResults)
        }
      }
      setTimeout(function() {
        // eslint-disable-next-line no-undef
        const service = new google.maps.places.PlacesService(map)
        service.nearbySearch(request, callback)
      }, parseInt(Math.pow(1.5, index)));
    })

  }

  const clearRoute = () => {
    setDirectionsResponse(null)
    setOrigin('')
    setDestination('')
    setDistance(null)
    setDuration(null)
    setPlaces([])
    setFilter('')
    originRef.current.value = ''
    destinationRef.current.value = ''
  }

  return (
    <div className='flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-row sm:flex-col min-w-screen h-screen bg-slate-100 font-fredokaMedium'>
      <div className='basis-1/5 flex flex-col rounded-lg p-4 2xl:pr-0 xl:pr-0 lg:pr-0 md:pr-0 sm:pr-4'>
        <div className='text-slate-700 font-bold text-6xl font-fredokaRegular'>
          Lunchliner
        </div>
        <div className='text-slate-700 font-thin text-2xl mt-2 font-fredokaRegular'>
          Find food ahead of time
        </div>
        <img src={Image} className='mt-2'/>
        <div className='flex flex-col rounded-lg bg-slate-200 h-full mt-4'>
          <div className='flex mx-auto mt-8'>
            <div className='my-auto mr-4'>Origin</div>
            <Autocomplete>
              <input
                type="text"
                placeholder='Enter a place'
                className='rounded-md p-2 w-fit'
                onChange={(e) => setOrigin(e.target.value)}
                ref={originRef}
              />
            </Autocomplete>
          </div>
          <div className='flex mt-4 mx-auto 2xl:mx-4 xl:mx-4 lg:mx-4 md:mx-4 sm:mx-auto '>
            <div className='my-auto mr-4'>Destination</div>
            <Autocomplete>
              <input
                type="text"
                placeholder='Enter a place'
                className='rounded-md p-2 w-fit'
                onChange={(e) => setDestination(e.target.value)}
                ref={destinationRef}
              />
            </Autocomplete>
          </div>
          <button className={`mx-auto w-1/2 rounded-md my-8 mb-4 py-2 ${(origin === '' || destination === '') ? 'opacity-50 bg-slate-400' : 'opacity-100 bg-[#f1ab4d]'}`} 
            disabled={origin === '' || destination === ''} onClick={calculateRoute}
          >
            Find Food
          </button>
          {directionsResponse != null ?
            <button className={`mx-auto w-1/2 rounded-md py-2 bg-slate-300`} onClick={clearRoute}>
              Clear Results
            </button>
            : <></>
          }
          {searchError ? 
            <div className='mx-auto px-8 mt-4 text-sm text-center text-red-600'>
              There was an error. Please make sure your locations are valid.
            </div>
            : <></>
          }
          {(distance != null && duration != null && searchError == false) ?
            <div className='flex flex-col mt-4 text-center'>
              <div>
                <strong>Distance:</strong> {distance != null ? distance : ''}
              </div>
              <div>
                <strong>Duration:</strong> {duration != null ? duration : ''}
              </div>
            </div>
            : <></>
          }
          {places.length > 0 ?
            <div className='flex flex-col bg-slate-200 mt-4 mx-auto text-center'>
              <span className='font-fredokaRegular'>Filters</span>
              <div className='mt-2'>
                <button className={`rounded-lg py-1 px-2 mr-4 ${filter == 'nearest' ? 'bg-[#f1ab4d]' : 'bg-slate-300'}`} onClick={() => setFilter('nearest')}>Nearest</button>
                <button className={`rounded-lg py-1 px-2 ${filter == 'farthest' ? 'bg-[#f1ab4d]' : 'bg-slate-300'}`}  onClick={() => setFilter('farthest')}>Farthest</button>
              </div>
              <div className='mt-2'>
                <button className={`rounded-lg py-1 px-2 mr-4 ${filter == 'cheap' ? 'bg-[#f1ab4d]' : 'bg-slate-300'}`}  onClick={() => setFilter('cheap')}>Cheap</button>
                <button className={`rounded-lg py-1 px-2 ${filter == 'expensive' ? 'bg-[#f1ab4d]' : 'bg-slate-300'}`}  onClick={() => setFilter('expensive')}>Expensive</button>
              </div>
              <div className='mt-2 mb-4'>
                <button className={`rounded-lg py-1 px-2 mr-4 ${filter == 'rated high' ? 'bg-[#f1ab4d]' : 'bg-slate-300'}`}  onClick={() => setFilter('rated high')}>Rated High</button>
                <button className={`rounded-lg py-1 px-2 ${filter == 'rated low' ? 'bg-[#f1ab4d]' : 'bg-slate-300'}`}  onClick={() => setFilter('rated low')}>Rated Low</button>
              </div>
            </div>
            : <></>
          }
        </div>
      </div>
      <div className='flex w-full flex-col 2xl:flex-row xl:flex-row lg:flex-col md:flex-col sm:flex-col mx-4 h-full'>
        {places.length > 0 ?
          <div className={`min-w-[400px] overflow-y-auto bg-slate-200 rounded-lg m-4 mx-0 2xl:mb-4 xl:mb-4 lg:mb-0 md:mb-0 sm:mb-0
            2xl:mr-4 xl:mr-4
            2xl:max-h-[100%] xl:max-h-[100%] lg:max-h-[50%] md:max-h-[50%] sm:max-h-[50%]`}>
            {places.map((place, i) => (
              <Card key={i} place={place} />
            ))}
          </div>
          : <></>
        }
        <div className={`rounded-lg w-full min-h-full lg:min-h-[50%] md:min-h-[50%] sm:min-h-[50%] py-4 pl-0 ${places.length == 0 ? 'lg:min-h-full md:min-h-full' : ''}`}>
          <GoogleMap
            center={center}
            zoom={10}
            className='rounded-lg'
            mapContainerStyle={{width: '100%', height: '100%', borderRadius: '10px'}}
            options={{
              zoomControl: false,
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
            }}
            onLoad={map => setMap(map)}
          >
            {places.length > 0 ?
              places.map((place, i) => (
                <Marker
                  key={i + 1}
                  position={{lat: place.geometry.location.lat(), lng: place.geometry.location.lng()}}
                />
              ))
              : <></>
            }
            {directionsResponse && <DirectionsRenderer directions={directionsResponse} />}
          </GoogleMap>
        </div>
      </div>
    </div>
  );
}

export default App;
